module.exports = __webpack_public_path__ + "static/media/knowledge_center.5170b57c.svg";